import React from 'react';
import { View, Text } from 'react-native';
import Unicon from '@/components/General/Unicon';
import { useUnistyles } from 'react-native-unistyles';

const EmptyState = ({ message = 'No files or folders here yet' }) => {
  const { theme: { colors } } = useUnistyles();

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 40 }}>
      <Unicon name="folder-open-outline" size={64} colorVariant="textSecondary" library="material" />
      <Text style={{ color: colors.textSecondary, fontSize: 16, marginTop: 16, textAlign: 'center' }}>
        {message}
      </Text>
    </View>
  );
};

export default EmptyState;
